import * as Sentry from '@sentry/react'
import { router } from '@inertiajs/react'

export function initSentry(): void {
  const dsn = document.querySelector<HTMLMetaElement>('meta[name="sentry-dsn"]')?.content
  if (!dsn) return

  const environment = document.querySelector<HTMLMetaElement>('meta[name="sentry-environment"]')?.content
  const release = document.querySelector<HTMLMetaElement>('meta[name="sentry-release"]')?.content

  Sentry.init({
    dsn,
    environment,
    release,
    sendDefaultPii: false,
    tracesSampleRate: 0.05,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
  })

  // Inertia の navigation 中に投げられた例外も Sentry に送る
  router.on('exception', (event) => {
    Sentry.captureException(event.detail.exception)
  })
}
